module.exports = __webpack_public_path__ + "img/39.3c5fdbcb.svg";